var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent1CON",
    d: "M77.5,13c-8.2,0-14.8,6.7-14.8,14.9v7.7h29.1c6,0,10.9-4.9,10.9-10.9V13H77.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent1CON",
    d: "m48.7 111.6h-13.1v-10.1c0-0.7 0.3-4 0.4-4.9 1.1-5 3.4-10 6.7-14 4.8-5.9 13.1-10.3 20.6-11.2 0.2 0-5 3.9-7.9 7.9-2.1 2.9-3 4.1-4.6 7.7-1.9 3.9-2.6 12.1-2.1 24.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m101.8 67.8-0.4-0.1c-0.2-0.1-0.5-0.1-0.7 0h-0.2l-4.9-0.2 3.3-3.2c4.5-4.4 7-10.4 7-16.7v-36.3c0-0.9-0.7-1.6-1.6-1.6h-26.8c-9.9 0-18 8.2-18 18.2v19.6c0 6.3 2.5 12.3 7 16.7l3.3 3.3-5 0.2h-0.4c-0.2 0-0.3 0-0.4 0.1l-0.4 0.1c-17.8 1.5-31.6 16.7-31.6 34.6v11.1c0 0.9 0.7 1.6 1.6 1.6h68.4c0.9 0 1.7-0.8 1.7-1.6s-0.8-1.6-1.7-1.6h-66.8v-5.6l0.2-7.5c1.7-14.5 13-25.9 27.4-27.6l1-0.1 17.7 17.8c0.6 0.6 1.7 0.6 2.3 0l17.7-18 1 0.1c15.8 1.9 27.6 15.4 27.6 31.4v9.4h-20.5c-0.9 0-1.7 0.8-1.7 1.6s0.8 1.6 1.7 1.6h22.2c0.9 0 1.6-0.7 1.6-1.6v-11.1c-0.1-17.8-13.9-33-31.6-34.6zm-39.1-39.9c0-8.2 6.6-14.9 14.8-14.9h25.1v11.7c0 6-4.9 10.9-10.9 10.9h-29v-7.7zm0 19.6v-8.7h29.1c2.8 0 5.4-0.8 7.7-2.3l3.1-2.1v13.1c0 11.1-9 20.1-20 20.1s-19.9-9-19.9-20.1zm19.9 37.9-14.3-14.5h28.7l-14.4 14.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m92.5 91.5c1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6-1.4 0-2.6-1.1-2.6-2.6s1.2-2.6 2.6-2.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m46 13.5c-0.5 0-0.9 0.4-0.9 0.8v1.9c0 0.5 0.4 0.9 0.9 0.9s0.8-0.4 0.8-0.8v-2c0-0.4-0.4-0.8-0.8-0.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m43.8 11.6h-1.9c-0.4 0-0.8 0.4-0.8 0.8 0 0.5 0.4 0.8 0.8 0.8h1.9c0.5 0 0.8-0.4 0.8-0.8s-0.3-0.8-0.8-0.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m46 7.7c-0.5 0-0.9 0.4-0.9 0.8v1.9c0 0.5 0.4 0.8 0.8 0.8 0.5 0 0.8-0.4 0.8-0.8v-1.9c0.1-0.4-0.3-0.8-0.7-0.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m50 11.5h-1.9c-0.5 0-0.8 0.4-0.8 0.8 0 0.5 0.4 0.8 0.8 0.8h1.9c0.5 0 0.8-0.4 0.8-0.8s-0.3-0.8-0.8-0.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent2CON",
    d: "m8.2 83.8s1.1 8-8.2 7.8c0 0 8 0.1 7.8 7.6 0 0 0.7-5.9 8.1-7.2 0-0.1-6.3 1.4-7.7-8.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent2CON",
    d: "m125.5 44.5s1.1 8-8.2 7.8c0 0 8 0.1 7.8 7.6 0 0 0.7-5.9 8.1-7.2 0-0.1-6.2 1.3-7.7-8.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m26.8 54.7s0.4 2.8-2.9 2.7c0 0 2.8 0 2.7 2.6 0 0 0.3-2 2.8-2.5 0.1 0.1-2.1 0.6-2.6-2.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m125 5.2c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6-1.2 2.6-2.6 2.6zm0-4.2c-0.9 0-1.6 0.7-1.6 1.6s0.7 1.6 1.6 1.6 1.6-0.7 1.6-1.6-0.7-1.6-1.6-1.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent2CON",
    d: "m5.6 28.2c-1.2 0-2.1-0.9-2.1-2.1s0.9-2.1 2.1-2.1 2.1 0.9 2.1 2.1-0.9 2.1-2.1 2.1zm0-3.2c-0.6 0-1.1 0.5-1.1 1.1s0.5 1.1 1.1 1.1 1.1-0.5 1.1-1.1-0.5-1.1-1.1-1.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m158.8 90.7c-0.7 0-1.3 0.6-1.3 1.4v3.2c0 0.8 0.6 1.4 1.3 1.4s1.3-0.6 1.3-1.4v-3.2c0-0.8-0.6-1.4-1.3-1.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m155.3 87.2h-3.2c-0.8 0-1.4 0.6-1.4 1.3s0.6 1.3 1.4 1.3h3.2c0.8 0 1.4-0.6 1.4-1.3s-0.6-1.3-1.4-1.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m158.8 80.4c-0.7 0-1.2 0.6-1.2 1.4v3.2c0 0.8 0.5 1.4 1.2 1.4s1.3-0.6 1.3-1.4v-3.2c0-0.8-0.6-1.4-1.3-1.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "profileIllPrimaryCON",
    d: "m165.6 87.2h-3.2c-0.8 0-1.4 0.6-1.4 1.3s0.6 1.3 1.4 1.3h3.2c0.8 0 1.4-0.6 1.4-1.3s-0.6-1.3-1.4-1.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "profileAccent1CON",
    d: "m62.7 38.9v8.7c0 10.8 8.5 19.6 19.2 20.1-5.8-2.1-11.5-7.8-11.5-13.3v-15.5h-7.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.f4b1e7112a64e3cd3dfbfe9a259d90ef.svg";
export { ForwardRef as ReactComponent };